export var showModal = function (data) { return function (dispatch) {
    if (!data.type)
        return;
    dispatch({
        type: 'SHOW_MODAL',
        data: data,
    });
}; };
export var closeModal = function (isIncomplete) {
    if (isIncomplete === void 0) { isIncomplete = false; }
    return function (dispatch) {
        dispatch({
            type: 'HIDE_MODAL',
            isIncomplete: isIncomplete,
        });
    };
};
